import React, { useState } from 'react';
import { AlertTriangle, ChevronDown, ChevronUp, ShieldAlert } from 'lucide-react';
import { Checkbox } from '../ui/checkbox';
import {
  NOTICE_TITLE, NOTICE_INTRO, NOTICE_LEAD, NOTICE_POINTS, SEARCH_CHECKBOX_LABEL,
  FINAL_TITLE, FINAL_POINTS, FINAL_CHECKBOX_LABEL,
} from './nonRefundableTerms';

export const NonRefundableNotice = ({ accepted, onChange, compact = false }) => {
  const [open, setOpen] = useState(!compact);
  return (
    <div className="rounded-xl border-2 border-amber-300 bg-amber-50 p-4" data-testid="nrf-notice">
      <button type="button" onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between gap-3 text-left" data-testid="nrf-notice-toggle">
        <span className="flex items-center gap-2 font-bold text-amber-900"><AlertTriangle className="h-5 w-5 text-amber-600" />{NOTICE_TITLE}</span>
        {open ? <ChevronUp className="h-4 w-4 text-amber-700" /> : <ChevronDown className="h-4 w-4 text-amber-700" />}
      </button>
      {open && (
        <div className="mt-3 text-sm text-amber-950 space-y-2" data-testid="nrf-notice-body">
          <p className="font-semibold">Please read carefully before continuing.</p>
          <p>{NOTICE_INTRO}</p>
          <p>{NOTICE_LEAD}</p>
          <ul className="list-disc pl-5 space-y-1">{NOTICE_POINTS.map((p, i) => <li key={i}>{p}</li>)}</ul>
        </div>
      )}
      <label className="mt-3 flex items-start gap-3 cursor-pointer rounded-lg bg-white/70 border border-amber-200 p-3" data-testid="nrf-notice-checkbox-label">
        <Checkbox checked={accepted} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5 border-amber-500 data-[state=checked]:bg-amber-600 data-[state=checked]:border-amber-600" data-testid="nrf-notice-checkbox" />
        <span className="text-sm font-semibold text-amber-900">{SEARCH_CHECKBOX_LABEL}</span>
      </label>
      {!accepted && <p className="mt-2 text-xs text-amber-700" data-testid="nrf-notice-hint">Tick the box above to continue to payment.</p>}
    </div>
  );
};

export const FinalBookingConfirmation = ({ accepted, onChange }) => (
  <div className="rounded-xl border-2 border-red-300 bg-red-50 p-4 sm:p-5" data-testid="final-confirmation">
    <div className="flex items-center gap-2 font-black text-red-800 tracking-wide"><ShieldAlert className="h-5 w-5" />{FINAL_TITLE}</div>
    <ul className="mt-3 space-y-2 text-sm text-red-950">
      {FINAL_POINTS.map((p, i) => <li key={i} className="flex gap-2"><span className="text-red-500 font-bold">•</span><span>{p}</span></li>)}
    </ul>
    <label className="mt-4 flex items-start gap-3 cursor-pointer rounded-lg bg-white border border-red-200 p-3" data-testid="final-confirmation-checkbox-label">
      <Checkbox checked={accepted} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5 border-red-500 data-[state=checked]:bg-red-600 data-[state=checked]:border-red-600" data-testid="final-confirmation-checkbox" />
      <span className="text-sm font-bold text-red-900">{FINAL_CHECKBOX_LABEL}</span>
    </label>
  </div>
);
